import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import validator from "validator"


export class ContactFormService{

    static getPostData(warningMessage, value) {
        const postData = {
            keywords: value,
            objects: ["contacts"],
            fields: [warningMessage],
            pageSize: 5,
            activePage: 1,
            sortByField: "createdAt",
            sortAsc: true,
            lightResult: true,
            filters: {},
        }
        if (typeof value != "string") {
            postData.keywords = "*"
            postData.filters[warningMessage] = value
        }
        return postData
    }

    static filterDuplicateList(duplicates, contactId) {
        return duplicates.data.filter(x => x.id !== contactId)
    }

    static async Get(id: string) {
        const res = await AppContext.getApiClient().get(`/contacts/${id}`)
        return res
    }

    static async CheckForDuplicate(warningMessage, value, contactId) {
        let res = await AppContext.getApiClient().post("/listing/search", this.getPostData(warningMessage, value))
        res = this.filterDuplicateList(res, contactId)
        return res
    }

    static async DeleteContact(contactId) {
        const res = await AppContext.getApiClient().delete(`/contacts/${contactId}`)
        return res
    }

    static SaveContact(contactId,companyIdentifier,payloadPerson,contactType) {
        let payload = {}
        if (!companyIdentifier ||  validator.isUUID(companyIdentifier)) {//we don't need to create an organization, just a contact
            payloadPerson["organizationId"] = companyIdentifier
            payload = payloadPerson
            
            if (contactId) { //it's an update
                return AppContext.getApiClient().patch(`/${contactType}/${contactId}`, payload)
            } else {
                return AppContext.getApiClient().post(`/${contactType}`, payload)
            }
        } else {
            if(contactId) {//it's an update of an existing contact and we need to create an organization first so we can assign it
                payload = {
                    name: companyIdentifier,
                    email: payloadPerson.email,
                    phoneNumbers: payloadPerson.phoneNumbers,
                    address: payloadPerson.address,
                }
                return AppContext.getApiClient().post("/organizations", payload).then((r) => {
                    payloadPerson["organizationId"] = r.id
                    return AppContext.getApiClient().patch(`/${contactType}/${contactId}`, payloadPerson)
                })
            } else {//it's a brand new contact with a brand new company, we can post everything through the company
                payload = {
                    name: companyIdentifier,
                    [contactType]: [ payloadPerson ],
                    email: payloadPerson.email,
                    phoneNumbers: payloadPerson.phoneNumbers,
                    address: payloadPerson.address,
                }
                return AppContext.getApiClient().post("/organizations", payload)
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/state/contact/services/ContactFormService.ts